<div class="input-group component-datepicker" [ngClass]="{'parse-error': parseError, 'disabled': isDisabled}">
  <input class="form-control"
         id="{{id}}"
         ngbDatepicker
         #d="ngbDatepicker"
         container="body"
         [disabled]="isDisabled"
         [placeholder]="placeholder"
         [placement]="['bottom-left', 'top-left']"
         [ngModel]="date"
         [markDisabled]="markDisabled"
         [minDate]="minDateParsed"
         [maxDate]="maxDateParsed"
         [footerTemplate]="footerTmpl"
         (ngModelChange)="onDateChange($event)">
  <div class="input-group-append">
    <button class="btn btn-calendar" (click)="toggle()" type="button">
      <img class="icon-calendar" src="/assets/images/icon-calendar.svg" />
    </button>
  </div>
</div>
<ng-template #footerTmpl>
  <button class="clear-btn" (click)="onDateChange(null, true)">Clear</button>
</ng-template>
